<script setup lang="ts">
const props = defineProps({
  content: {
    type: Object,
    required: true,
    default() {
      return {};
    },
  },
});

const headline = computed(() => props?.content?.headline);
const accordions = computed(() => props?.content?.Accordion || []);
const fullWidth = computed(() => props?.content?.fullWidth);
</script>

<template>
  <div class="accordion">
    <div :class="{ container: !fullWidth }">
      <h2 v-if="headline">{{ headline }}</h2>

      <div class="space-y-2 max-w-[1000px]">
        <SharedCollapsible
          v-for="item in accordions"
          :key="item.id"
          :title="item.title"
          :content="item.content"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.accordion {
  @apply pb-14;

  h2 {
    @apply text-lg font-bold uppercase mb-2;
  }
}
</style>
